export default __webpack_public_path__ + "df18cad4737ca14f6127405a9dc7fb40.png";